import { msalInstance } from '../index';

class APIUtils {

    GATE_API = "gate-api";

    getBaseUrl() {
        return process.env.REACT_APP_API_URL;
    }

    getHeaders(cb) {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        if (localStorage.hasOwnProperty('userData')) {
            let user = JSON.parse(localStorage.getItem('userData'));
            headers.append('auth_token', user.userToken);
        }
        cb(headers);
    }

    postOptions(payload) {

        const options = {};
        options.method = "POST";
        options.payload = payload;
        options.headers = this.getHeadersPost();
        return options;
    }


    getAWSUrl() {
      return process.env.REACT_APP_AWS_URL ?? "https://api.test.sainsburysargosgiftcard.co.uk";
  }

    async getAWSHeaders() {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        
        try {
            const accounts = msalInstance.getAllAccounts();
            if (accounts.length > 0) {
                const request = {
                    scopes: [`api://${process.env.REACT_APP_SSO_CLIENTID}/access_as_user`],
                    account: accounts[0]
                };

                const response = await msalInstance.acquireTokenSilent(request);
                headers.append('Authorization', `Bearer ${response.accessToken}`);
            } else {
                window.location.href = '/';
            }
        } catch (error) {
            console.error('Failed to acquire token silently:', error);
        }
        
        return headers;
    }

    async getAuthorizationHeader() {
        const headers = await this.getAWSHeaders();
        return { Authorization: headers.get("Authorization") || "" };
    };

    getUrlParams(urlParams) {
        const params = new URLSearchParams();
        for (const key in urlParams) {
            params.append(key, urlParams[key]);
        }
        return `?${params.toString()}`;
    }
}

export default new APIUtils();